import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Switch, message, Tag, Space, Button } from "antd";
import { DashboardOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import axios from 'axios';
import consts from '../../constant';
import * as settingsService from "../../services/settingsService";
import Loadingpage from "../Loadingpage/Loadingpage";
import Chart from "./chart";
import BarChart from "./barchart"

const Home = () => {
  const navigate = useNavigate();
  const [analytics, setAnalytics] = useState({});
  const [rtpData, setRtpData] = useState(null);
  let [load, setLoad] = useState(false);
  const [crmMaintenance, setCrmMaintenance] = useState(false);
  const [tradeMaintenance, setTradeMaintenance] = useState(false);


  const myData = analytics?.tradeTypes ? [
    { name: "Binary", value: analytics.tradeTypes.highlow.count, fill: "#A94A4A" },
    { name: "Spin And Win", value: analytics.tradeTypes.highlowSpread.count, fill: "#F08080" },
  ] : [
    { name: "Binary", value: 0, fill: "#A94A4A" },
    { name: "Spin And Win", value: 0, fill: "#F08080" },
  ];

  const profitLossData = analytics?.trades ? [
    { name: "Total Wins", value: analytics.trades.loss, fill: "#00C49F" },
    { name: "Total Loss", value: analytics.trades.win, fill: "#FF4D4F" },
  ] : [
    { name: "Total Wins", value: 0, fill: "#00C49F" },
    { name: "Total Loss", value: 0, fill: "#FF4D4F" },
  ];
  const userWinAmountData = analytics?.financials ? [
    { name: "Win Amount", value: analytics.financials.payout, fill: "#00C49F" },
    { name: "Loss Amount", value: analytics.financials.revenue, fill: "#FF4D4F" },
  ] : [
    { name: "Win Amount", value: 0, fill: "#00C49F" },
    { name: "Loss Amount", value: 0, fill: "#FF4D4F" },
  ];

  const getAnalytics = async () => {
    setLoad(true);
    try {
      const response = await axios.post(`${consts.BackendUrl}/getDashboardDetails`, {}, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
        },
      })
      if (response?.data?.success) {
        setAnalytics(response?.data?.result);
      }
    } catch (error) {
      console.log(error);
    }
    setLoad(false);
  }

  const getSystemSettings = async () => {
    try {
      const response = await axios.get(`${consts.BackendUrl}/settings/getSystemSettings`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
        },
      });
      if (response.data.success) {
        setCrmMaintenance(response.data.result.crm_maintenance);
        setTradeMaintenance(response.data.result.trade_maintenance);
      }
    } catch (error) {
      console.error("Error fetching system settings:", error);
    }
  };

  const updateMaintenance = async (type, value) => {
    try {
      const payload = type === "crm" ? { crm_maintenance: value } : { trade_maintenance: value };
      const response = await axios.post(`${consts.BackendUrl}/settings/updateSystemSettings`, payload, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
        },
      });
      if (response.data.success) {
        if (type === "crm") setCrmMaintenance(value);
        else setTradeMaintenance(value);
        message.success(`${type.toUpperCase()} Maintenance ${value ? "Enabled" : "Disabled"}`);
      }
    } catch (error) {
      message.error("Failed to update maintenance mode");
      console.error("Error updating system settings:", error);
    }
  };


  const getRtpOverview = async () => {
    try {
      const res = await settingsService.getRtpAnalytics("24h", false);
      if (res?.success && res.result) {
        setRtpData(res.result);
      }
    } catch (e) {
      console.log("Error fetching RTP overview:", e);
    }
  };

  useEffect(() => {
    getAnalytics();
    getSystemSettings();
    getRtpOverview();
  }, []);

  return (
    <>
      {/* {load && <Loadingpage />} */}
      <Loadingpage />
      <div>
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center", 
          marginBottom: "20px",
        }}>
          <h2 style={{ margin: 0, color: "#fff" }}>Dashboard</h2>
        </div>

        {/* Automated Target RTP Engine Overview Widget */}
        <Card
          style={{
            marginBottom: "24px",
            backgroundColor: "#161B22",
            borderColor:
              rtpData?.state === "HOUSE_PRESERVATION"
                ? "rgba(245, 158, 11, 0.4)"
                : rtpData?.state === "PLAYER_RETENTION"
                ? "rgba(6, 182, 212, 0.4)"
                : "rgba(16, 185, 129, 0.4)",
            borderRadius: "12px",
          }}
          bodyStyle={{ padding: "16px 20px" }}
        >
          <Row align="middle" justify="space-between" gutter={[16, 16]}>
            <Col xs={24} md={16}>
              <Space wrap align="center">
                <DashboardOutlined style={{ fontSize: "20px", color: "#FC4420" }} />
                <span style={{ fontSize: "15px", fontWeight: 600, color: "#FFF" }}>
                  Automated Target RTP Engine (24h)
                </span>
                <Tag
                  color={
                    rtpData?.state === "HOUSE_PRESERVATION"
                      ? "warning"
                      : rtpData?.state === "PLAYER_RETENTION"
                      ? "processing"
                      : "success"
                  }
                  style={{ fontWeight: 600 }}
                >
                  {rtpData?.state || "BALANCED"}
                </Tag>
                <Tag color={rtpData?.settings?.enabled ? "green" : "default"}>
                  {rtpData?.settings?.enabled ? "AUTOMATED ACTIVE" : "ENGINE PAUSED"}
                </Tag>
              </Space>
              <div
                style={{
                  marginTop: "8px",
                  display: "flex",
                  gap: "20px",
                  flexWrap: "wrap",
                  fontSize: "13px",
                }}
              >
                <span style={{ color: "#94A3B8" }}>
                  Target RTP:{" "}
                  <strong style={{ color: "#FFF" }}>
                    {rtpData?.settings?.targetRtp || 94.0}%
                  </strong>
                </span>
                <span style={{ color: "#94A3B8" }}>
                  Realized RTP:{" "}
                  <strong style={{ color: "#10B981" }}>
                    {Number(rtpData?.metrics?.realizedRtp || 94.0).toFixed(2)}%
                  </strong>
                </span>
                <span style={{ color: "#94A3B8" }}>
                  Turnover:{" "}
                  <strong style={{ color: "#FFF" }}>
                    ${Number(rtpData?.metrics?.totalTurnover || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </strong>
                </span>
                <span style={{ color: "#94A3B8" }}>
                  House Profit:{" "}
                  <strong style={{ color: "#10B981" }}>
                    +${Number(rtpData?.metrics?.netProfit || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </strong>
                </span>
              </div>
            </Col>
            <Col xs={24} md={8} style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<ArrowRightOutlined />}
                onClick={() => navigate(`/${consts.route}/tradesetting/rtp-engine`)}
                style={{
                  backgroundColor: "#FC4420",
                  borderColor: "#FC4420",
                  fontWeight: 600,
                }}
              >
                Manage RTP Engine
              </Button>
            </Col>
          </Row>
        </Card>

        <Row gutter={[16, 16]} style={{ marginBottom: "30px" }}>

          <Col xs={24} sm={12} md={8}>
            <Card className="card-bg-clr">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke=" #FC4420"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-user-round-icon lucide-user-round"
                  >
                    <circle cx="12" cy="8" r="5" />
                    <path d="M20 21a8 8 0 0 0-16 0" />
                  </svg>
                </div>
                <div>
                  <h3 className="dashboard-card-title">Total Users</h3>
                  <p className="dashboard-card-para">
                    {analytics?.totalUsers ?? 0}
                  </p>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card className="card-bg-clr">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 20 20"
                    fill="none"
                    stroke="#FC4420"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-repeat2-icon lucide-repeat-2"
                  >
                    <path d="m2 9 3-3 3 3" />
                    <path d="M13 18H7a2 2 0 0 1-2-2V6" />
                    <path d="m22 15-3 3-3-3" />
                    <path d="M11 6h6a2 2 0 0 1 2 2v10" />
                  </svg>
                </div>
                <div>
                  <h3 className="dashboard-card-title">Total Deposits</h3>
                  <p className="dashboard-card-para">
                    {analytics?.deposits?.totalAmount ?? 0}
                  </p>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card className="card-bg-clr">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FC4420"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-clipboard-clock-icon lucide-clipboard-clock"
                  >
                    <path d="M16 14v2.2l1.6 1" />
                    <path d="M16 4h2a2 2 0 0 1 2 2v.832" />
                    <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2" />
                    <circle cx="16" cy="16" r="6" />
                    <rect x="8" y="2" width="8" height="4" rx="1" />
                  </svg>
                </div>
                <div>
                  <h3 className="dashboard-card-title">Pending Deposits</h3>
                  <p className="dashboard-card-para">
                    {analytics?.deposits?.pendingCount ?? 0}
                  </p>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card className="card-bg-clr">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 22 22"
                    fill="none"
                    stroke="#FC4420"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-banknote-arrow-down-icon lucide-banknote-arrow-down"
                  >
                    <path d="M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" />
                    <path d="m16 19 3 3 3-3" />
                    <path d="M18 12h.01" />
                    <path d="M19 16v6" />
                    <path d="M6 12h.01" />
                    <circle cx="12" cy="12" r="2" />
                  </svg>
                </div>
                <div>
                  <h3 className="dashboard-card-title">Total Withdraw</h3>
                  <p className="dashboard-card-para">
                    {analytics?.withdrawals?.totalAmount ?? 0}
                  </p>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card className="card-bg-clr">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FC4420"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-clock-arrow-down-icon lucide-clock-arrow-down"
                  >
                    <path d="M12 6v6l2 1" />
                    <path d="M12.337 21.994a10 10 0 1 1 9.588-8.767" />
                    <path d="m14 18 4 4 4-4" />
                    <path d="M18 14v8" />
                  </svg>
                </div>
                <div>
                  <h3 className="dashboard-card-title">Pending Withdraw</h3>
                  <p className="dashboard-card-para">
                    {analytics?.withdrawals?.pendingCount ?? 0}
                  </p>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card className="card-bg-clr">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FC4420"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-shield-check-icon lucide-shield-check"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                </div>
                <div>
                  <h3 className="dashboard-card-title">Total Revenue</h3>
                  <p className="dashboard-card-para">
                    {analytics?.financials?.revenue ?? 0}
                  </p>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card className="card-bg-clr">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FC4420"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-badge-pound-sterling-icon lucide-badge-pound-sterling"
                  >
                    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                    <path d="M8 12h4" />
                    <path d="M10 16V9.5a2.5 2.5 0 0 1 5 0" />
                    <path d="M8 16h7" />
                  </svg>
                </div>
                <div>
                  <h3 className="dashboard-card-title">Total Bet Amount</h3>
                  <p className="dashboard-card-para">
                    {analytics?.financials?.totalBetAmount ?? 0}
                  </p>
                </div>
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Card className="card-bg-clr">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FC4420"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-trending-up-icon lucide-trending-up"
                  >
                    <path d="M16 7h6v6" />
                    <path d="m22 7-8.5 8.5-5-5L2 17" />
                  </svg>
                </div>
                <div>
                  <h3 className="dashboard-card-title">
                    Highest Pairs To bet{" "}
                  </h3>
                  <p className="dashboard-card-para">
                    {analytics?.pairs?.highest ?? "-"}
                  </p>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Card className="card-bg-clr">
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-center",
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FC4420"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-trending-down-icon lucide-trending-down"
                  >
                    <path d="M16 17h6v-6" />
                    <path d="m22 17-8.5-8.5-5 5L2 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="dashboard-card-title">lowest Pairs To bet</h3>
                  <p className="dashboard-card-para">
                    {analytics?.pairs?.lowest ?? "-"}
                  </p>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} lg={12}>
            <Card className="card-bg-clr">
              <h2 className="card-title">Total Trade History</h2>
              <Chart data={myData} type="normal" />
            </Card>
          </Col>

          <Col xs={24} sm={24} lg={12}>
            <Card className="card-bg-clr">
              <h2 className="card-title">User Profit & Loss</h2>
              <Chart data={profitLossData} type="rounded" />
            </Card>
          </Col>

          <Col xs={24} sm={24} lg={12}>
            <Card className="card-bg-clr">
              <h2 className="card-title">User Bet Amount</h2>
              <Chart data={userWinAmountData} type="rounded" />
            </Card>
          </Col>

          <Col xs={24} sm={24} lg={12}>
            <Card className="card-bg-clr">
              <h2 className="card-title">Highest & Lowest Pairs </h2>
              <BarChart
                data={
                  analytics?.topPairs
                    ? analytics.topPairs.slice(0, 2).map((p, i) => ({
                      ...p,
                      displayName: `${p.name} (${p.value})` || "-",
                      fill: i === 0 ? "#00C49F" : "#FF4D4F",
                    }))
                    : [
                      {
                        displayName: "Highest(0)",
                        value: 0,
                        fill: "#00C49F",
                      },
                      { displayName: "Lowest(0)", value: 0, fill: "#FF4D4F" },
                    ]
                }
                dataKey="value"
              />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Home;
